import { render, staticRenderFns } from "./uniqueUsersAreaChart.vue?vue&type=template&id=4f8c70df&scoped=true"
import script from "./uniqueUsersAreaChart.vue?vue&type=script&lang=js"
export * from "./uniqueUsersAreaChart.vue?vue&type=script&lang=js"
import style0 from "./uniqueUsersAreaChart.vue?vue&type=style&index=0&id=4f8c70df&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f8c70df",
  null
  
)

export default component.exports